import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const ChevronRight = (props: IconProps) => {
  const { color } = props;
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 24 24">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke={color ? color : "#808C92"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
   </SvgIcon>
  );
}

export default ChevronRight;